// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_86-0";
export var optionCard = "_86-1";